import { redirect } from '@tanstack/react-router'

import { getSession } from '@/features/auth/session-store'
import { withoutHandoffParams } from '@/features/auth/bootstrap'

/**
 * Sends anyone without a session to sign in, remembering where they meant to go.
 *
 * The session is read straight from the store rather than from a loader, because
 * `bootstrapSession` has already resolved it before the router was created --
 * there is nothing left to await here and no state in which it is still arriving.
 */
export function requireAuth({ location }: { location: { href: string } }): void {
  if (getSession().authenticated) return

  throw redirect({
    to: '/login',
    search: { original: withoutHandoffParams(location.href) },
  })
}

/**
 * Refuses a route to a signed-in user who is not staff.
 *
 * Enforced on the route rather than by hiding the link, because a hidden link is
 * not access control -- the url still works when typed.
 */
export function requireStaff(context: { location: { href: string } }): void {
  requireAuth(context)

  if (getSession().user?.is_staff !== true) {
    throw redirect({ to: '/' })
  }
}

/** Keeps a signed-in user off the sign-in page. */
export function redirectIfSignedIn(): void {
  if (getSession().authenticated) {
    throw redirect({ to: '/dashboard' })
  }
}
